import isInteger from 'lodash/isInteger'

export default popin

/** @ngInject */
function popin($timeout) {
    return ({
        restrict: 'E',
        template: require('./popin.jade')(),
        transclude: true,
        scope: {
            displayDelay: '=?',
            foldDelay: '=?',
        },
        link(scope) {
            scope.displayDelay = isInteger(scope.displayDelay) ? scope.displayDelay : 0
            scope.popin = { isDisplay: false, isFold: false }
            scope.popinClass = () => ({
                'popin-visible': scope.popin.isDisplay,
                'popin-hidden': !scope.popin.isDisplay,
                'popin-fold-open': scope.popin.isFold,
                'popin-fold-close': !scope.popin.isFold,
            })

            const enablePopin = () => {
                scope.popin.isDisplay = true
            }

            const foldPopin = () => {
                scope.popin.isFold = true
            }

            $timeout(enablePopin, scope.displayDelay)

            if (isInteger(scope.displayDelay)) {
                $timeout(foldPopin, scope.foldDelay)
            }
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/popin/popin.directive.js